import React, { useState, useContext, useMemo, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import GetAppIcon from '@mui/icons-material/GetApp';

import UserService from "services/UserService";
import axios from "axios";
import { getMBMAVOBBoxs } from "services/ConfigServices";
import { avobboxtext } from "variables/MBM/avobbox";
import { typeData, serverTypeLorawanGateway } from "variables/MBM/lists/avobbox";
import moment from "moment";

import { downloadCSV } from "utilities/exporttabletocsv";
import Button from "components/CustomButtons/Button.js";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";
import AddGateway from "./AddGateway";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

export default function useGatewayTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const currentusertype = localStorage.getItem('userType');
  const mbm_admin = permis.includes("mbm_admin") && currentusertype == 1; //not in prod yet
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const [totalRows, setTotalRows] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const url = getMBMAVOBBoxs(chartIdGroup, "gateways");
  const [results, setResults] = useState({ meters: [] });
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [avobboxsdata, setAvobboxsData] = useState([]);
  const [avobboxs, setAvobboxs] = useState([]);

  const refreshTable = () => {
    setRefresh(!refresh);
  }

  //Ok but should not be able to change group at this level
  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      if ((prevIdGroup && prevIdGroup === chartIdGroup)
        && (prevRefresh && prevRefresh === refresh)) {
        return;
      }
      //setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          url,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );

        setResults(response.data);
        setAvobboxsData(response.data.avobboxs);
        setLoading(false);
      }
      prevRefresh = refresh;
      prevIdGroup = chartIdGroup;
      fetchData();
    }
  }, [chartIdGroup, refresh]);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px", marginRight: "10px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const filteredItems = _.get(results, `avobboxs`, []).filter(
    (item) =>
      (item.name && item.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.gatewayid && item.gatewayid.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.otherparameters?.hardware && item.otherparameters.hardware.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.description && item.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.otherparameters?.server && item.otherparameters.server.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.otherparameters?.servertype && serverTypeLorawanGateway.find((x) => x.id == item.otherparameters.servertype) && serverTypeLorawanGateway.find((x) => x.id == item.otherparameters.servertype).name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.lastconnection && moment(item.lastconnection).isValid() && moment(item.lastconnection).format("DD/MM/YYYY hh:mm:ss").includes(filterText)) ||
      (item.groupid && groupInfoListById["" + item.groupid] && groupInfoListById["" + item.groupid].toLowerCase().includes(filterText.toLowerCase()))
  );

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    const onFilterText = (e) => setFilterText(e.target.value);
    let exportarray = avobboxs.map((item) => {
      let avobboxtoexport = {};
      avobboxtoexport[avobboxtext.id] = item.id;
      avobboxtoexport[avobboxtext.euid] = item.gatewayid;
      avobboxtoexport[avobboxtext.name] = item.name;
      avobboxtoexport[avobboxtext.description] = item.description;
      avobboxtoexport[avobboxtext.gatewayhardware] = item.otherparameters?.hardware || "";
      avobboxtoexport[avobboxtext.servertype] = item.otherparameters?.servertype ? serverTypeLorawanGateway.find((x) => x.id == item.otherparameters.servertype)?.name : "";
      avobboxtoexport[avobboxtext.server] = item.otherparameters?.server || "";
      avobboxtoexport[avobboxtext.group] = groupInfoListById["" + item.groupid];
      avobboxtoexport[avobboxtext.lastconnection] = (item.lastconnection && moment(item.lastconnection).isValid()) ? moment(item.lastconnection).format("DD/MM/YYYY hh:mm:ss") : "";
      return avobboxtoexport;
    });
    return (
      <>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {mbm_admin && (
          <>
            <UploadButton type="button" onClick={handleClear}>
              {/* <AddGateway refetch={refreshTable} onClick={handleClear} /> */}
            </UploadButton>
            <UploadButton type="button" onClick={handleClear}>
              {/* <EditMeters refetch={refreshTable} onClick={handleClear} marketmeters={marketmeters} disabled={!marketmeters || marketmeters.length < 1} /> */}
            </UploadButton>
            <UploadButton type="button" onClick={handleClear}>
              {/* <DeleteMeters refetch={refreshTable} onClick={handleClear} marketmeters={marketmeters} disabled={!marketmeters || marketmeters.length < 1} /> */}
            </UploadButton>
          </>
        )}
        <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!avobboxs || avobboxs.length < 1} />
        </UploadButton>
      </>
    );
  }, [filterText, resetPaginationToggle, avobboxsdata, avobboxs]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading,
    },
    refetch: refreshTable,
    setAvobboxs
  };
}
